import {
  Component,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  ViewContainerRef,
  ViewChild,
  EventEmitter,
  AfterViewInit,
  OnInit,
  OnDestroy
} from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import { UserUpdateComponent } from '../update.user/user.update.component';
import { ActivatedRoute } from '@angular/router';
import { UserService, ValuesExchangeProvider } from '@nrwl/common-lib';
import { AddUserGroupService } from '../new.user.group/add.user.group.service';
import { Subscription } from 'rxjs';
import { UserUpdateService } from './user.update.service';
import { WizardComponent } from '../../../wizard.component';
import { IWizardEntry } from '../../../wizard.entry';
import { UpdateUserResultsComponent } from './user.update.results/user.update.results.component';
import { get, merge } from 'lodash';
import { FusionSsoUserUpdateComponent } from './update.user.fusion.sso.component';

@Component({
  selector: 'user-wizard',
  providers: [UserWizardService],
  templateUrl: '../../../wizard.template.html',
  styleUrls: [
    '../../../wizard.component.style.scss',
    '../../../wizard.button.style.scss',
    '../wizard.user.style.scss'
  ]
})
export class UserUpdateWizardComponent
  extends WizardComponent
  implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
  @ViewChild('contentPlaceholder', { read: ViewContainerRef, static: true })
  contentRef: ViewContainerRef;
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef, static: true })
  subContentRef: ViewContainerRef;
  // eslint-disable-next-line @typescript-eslint/ban-types
  wizardConfig: object;
  wizardId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataId: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose = new EventEmitter<any>();

  wizardService: AddUserGroupService;
  userService: UserService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;

  constructor(
    wizardService: UserUpdateService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider
  ) {
    super();
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(data => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', '{}')));

      this.wizardService.editMode = true;
      this.exchange.notifyListeners('fusion-user-update-info', false);
      this.exchange.notifyListeners('user_admin_board', false);
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
      this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  get(object: any, path: string): any {
    return get(object, path);
  }

  //-------------- Control && Validation -----------------------
  toggleNext(): void {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack(): void {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish(): void {
    const result = this.wizardService.onFinish();
    result.subscribe(() => {
      this.createContentComponent();
    });
  }

  toggleClose(): void {
    this.wizardService.toggleClose(() => this.onClose.emit(true));
  }

  toggleReOpen(): void {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff: boolean): void {
    if (onOff) {
      this.createSubContentComponent();
    } else {
      this.subContentRef.clear();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWizardService(): any {
    return this.wizardService;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFactoryResolver(): any {
    return this.factoryResolver;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getContentViewRef(): any {
    return this.contentRef;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSubContentViewRef(): any {
    return this.subContentRef;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveComponentType(pageId: string): any {
    switch (pageId) {
      case 'user.update.html': {
        return UserUpdateComponent;
      }
      case 'update.user.fusion.sso.html': {
        return FusionSsoUserUpdateComponent;
      }
      case 'user.update.results.html': {
        return UpdateUserResultsComponent;
      }
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
}
